import {
  validateEmail,
  validateName,
  validateRequired,
  validateString,
  validationObject,
} from 'utils/validations';
import { filterOptions, getFormInitialValues } from 'utils/methods/helpers';
import { TASK_STATUS, TASK_TYPE } from 'utils/constants/task';
import { TASK_FIELDS } from 'utils/formFields/task';
import { departmentFilter } from 'containers/Pages/People/Personnel/Layouts/options.jsx';
import { serviceTypes } from 'utils/constants/serviceTypes.js';

export const defaultValues = {
  taskType: TASK_TYPE.CLEANING.id,
  isTemplate: true,
  status: TASK_STATUS.NEW.id,
};

export const initialValues = data => {
  return getFormInitialValues(data);
};

export const validationSchema = validationObject({
  image: validateRequired(),
  employeeId: validateString(30, false),
  firstName: validateName(30),
  lastName: validateName(30),
  email: validateEmail(true),
  businessClient: validateRequired(),
});

export const filters = ({
  bizClients,
  minDate,
  sites,
  businessClient,
  cleaningStatusFilters,
  companyId,
  userAssignedDepartments,
}) => {
  return {
    RegularFilters: [
      {
        label: 'dateFrom',
        field: 'dateFrom',
        type: 'date-picker',
      },
      {
        label: 'dateTo',
        field: 'dateTo',
        type: 'date-picker',
        minDate,
      },
      {
        label: 'status',
        field: 'status',
        type: 'select',
        options: cleaningStatusFilters,
        multiple: true,
        placeholder: 'Status',
      },
    ],
    AdvancedFilters: [
      {
        label: 'businessClient',
        field: 'businessClient',
        type: 'select',
        options: bizClients,
      },
      TASK_FIELDS.asyncTaskTypeFilter({
        companyId,
        category: serviceTypes.cleaning,
      }),
      {
        label: 'site',
        field: 'site',
        type: 'select',
        options: filterOptions({
          options: sites,
          filterKey: 'businessClientId',
          filterValue: businessClient,
        }),
      },
      TASK_FIELDS.linkAssetId({
        securityCompanyId: companyId,
        archived: false,
        // multiple: true,
        useAsyncInFilters: true, // if you are using async-select in filters make sure this is set to true
      }),
      ...departmentFilter(userAssignedDepartments),
    ],
  };
};
